module.exports = __webpack_public_path__ + "img/interrogation-mark.31df23a5.png";